import { render, staticRenderFns } from "./AuthorsSearch.vue?vue&type=template&id=0c558786&"
import script from "./AuthorsSearch.vue?vue&type=script&lang=js&"
export * from "./AuthorsSearch.vue?vue&type=script&lang=js&"
import style0 from "./AuthorsSearch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports